import React from 'react';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator,
} from '@mui/lab';
import {
  AppRegistration,
  Description,
  ManageAccounts,
  PaymentsOutlined,
  UploadFile,
} from '@mui/icons-material';
import styles from './SignUpTimeLine.module.scss';

const SignUpTimeLine = () => (
  <Timeline position="alternate">
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className={styles.timeLineDot} variant="outlined">
          <AppRegistration />
        </TimelineDot>
        <TimelineConnector className={styles.timeLineConnector} />
      </TimelineSeparator>
      <TimelineContent className={styles.timeLineContent}>
        Регистрируйтесь в Агентском кабинете
      </TimelineContent>
    </TimelineItem>
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className={styles.timeLineDot} variant="outlined">
          <UploadFile />
        </TimelineDot>
        <TimelineConnector className={styles.timeLineConnector} />
      </TimelineSeparator>
      <TimelineContent className={styles.timeLineContent}>
        Направляйте заявку с данными потенциального заёмщика
      </TimelineContent>
    </TimelineItem>
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className={styles.timeLineDot} variant="outlined">
          <ManageAccounts />
        </TimelineDot>
        <TimelineConnector className={styles.timeLineConnector} />
      </TimelineSeparator>
      <TimelineContent className={styles.timeLineContent}>
        Отслеживайте текущий статус направленной заявки в Агентском кабинете
      </TimelineContent>
    </TimelineItem>
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className={styles.timeLineDot} variant="outlined">
          <Description />
        </TimelineDot>
        <TimelineConnector className={styles.timeLineConnector} />
      </TimelineSeparator>
      <TimelineContent className={styles.timeLineContent}>
        Заёмщик получает заём
      </TimelineContent>
    </TimelineItem>
    <TimelineItem>
      <TimelineSeparator>
        <TimelineDot className={styles.timeLineDot} variant="outlined">
          <PaymentsOutlined />
        </TimelineDot>
      </TimelineSeparator>
      <TimelineContent className={styles.timeLineContent}>
        Подписание документа и выплата агентского вознаграждения
      </TimelineContent>
    </TimelineItem>
  </Timeline>
);

export default SignUpTimeLine;
